type Role = 'agent' | 'lead' | 'admin';

export const ROLE_RANK: Record<Role, number> = {
	agent: 0,
	lead: 1,
	admin: 2,
};

export function hasMinRole(userRole: Role, minimumRole: Role): boolean {
	return ROLE_RANK[userRole] >= ROLE_RANK[minimumRole];
}
